import { createFileRoute, redirect } from "@tanstack/react-router";

import { cleanSessions } from "@onesolution/utils";

export const Route = createFileRoute("/(auth)/logout")({
	beforeLoad: async () => {
		await cleanSessions();

		throw redirect({ to: "/login" });
	},
});
